import React from 'react';
import styled from 'styled-components';
import Header from './components/Header';
import { ntvImages } from '../Theming/images';
import { ANALYTICS_PAGE_NAMES, useIsIPad } from '../Common/Analytics/utils';
import { usePageViewTracking } from '../Common/Hooks';

const Container = styled.div<{ isIPad?: boolean }>`
  flex: 1;
  flex-direction: column;
  display: flex;
  max-height: 100dvh;
  max-width: ${(props) => (props.isIPad ? '100%' : '600px')};
  margin: 0 auto;
`;

const Description = styled.span<{ isIPad?: boolean }>`
  font-weight: 400;
  font-size: ${({ isIPad }) => (isIPad ? '24px' : '18px')};
  line-height: ${({ isIPad }) => (isIPad ? '32px' : '24px')};
  display: block;
  margin-top: 24px;
`;

const TextContainer = styled.div`
  padding-inline: 40px;
`;

const TitleText = styled.span<{ isIPad?: boolean }>`
  display: block;
  line-height: ${({ isIPad }) => (isIPad ? '42px' : '34px')};
  font-size: ${({ isIPad }) => (isIPad ? '32px' : '26px')};
`;

const InfoContainer = styled.div<{ isIPad?: boolean }>`
  padding-top: 5vh;
  padding-inline: 37px;

  ${({ isIPad }) =>
    isIPad &&
    `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: left;
  `}
`;

const InfoTitle = styled.h3<{ isIPad?: boolean }>`
  font-weight: 700;
  font-size: ${({ isIPad }) => (isIPad ? '32px' : '22px')};
  margin: 20px 0 25px 0;
`;

const ActivationStepsContainer = styled.div<{
  $fontSize?: string;
  isIPad?: boolean;
}>`
  flex-direction: row;
  display: flex;
  height: 300px;
  justify-content: center;
  width: 100%;

  & > img {
    height: 100%;
    margin-top: -7px;
    margin-left: 10px;
  }

  & > ol {
    padding: 0 0 0 10px;
    margin: 0;
    list-style-type: decimal;
    font-size: ${({ $fontSize, isIPad }) =>
      isIPad ? '20px' : $fontSize ? $fontSize : '16px'};
    font-weight: 400;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    & > li {
      line-height: 1.5;
      margin: 0;
      align-items: center;

      :not(:last-child) {
        margin-bottom: 20px;
      }
    }
  }
`;

const InfoContentWrapper = styled.div<{ isIPad?: boolean }>`
  ${({ isIPad }) =>
    isIPad &&
    `
    text-align: left;
  `}
`;

const NTVPluginActivationPartialPermissions = () => {
  const isIPad = useIsIPad();
  const { partially_installed_page } = ANALYTICS_PAGE_NAMES;
  usePageViewTracking(partially_installed_page, 'NTV');
  const infoItems = [
    'Einstellungen öffnen',
    'Safari auswählen',
    'Scrolle nach unten zu Allgemein – Erweiterungen.',
    '“ntv Shopping Deals” auswählen',
    '“ntv Shopping Deals” und andere Webseiten erlauben',
  ];

  return (
    <Container isIPad={isIPad}>
      <Header
        logoWidth={51}
        height={283}
        text={
          <TextContainer>
            <TitleText isIPad={isIPad}>ntv Shopping Deals</TitleText>
            <TitleText isIPad={isIPad}>ist nicht aktiv</TitleText>
            <Description isIPad={isIPad}>
              Das automatische Anzeigen von passenden Rabattcodes ist uns nicht
              möglich, wenn Sie die Browsererweiterung nicht aktivieren.
            </Description>
          </TextContainer>
        }
      />

      <InfoContainer isIPad={isIPad}>
        <InfoContentWrapper isIPad={isIPad}>
          <InfoTitle isIPad={isIPad}>Das müssen Sie tun:</InfoTitle>
          <ActivationStepsContainer
            $fontSize={window.screen.width > 380 ? '16px' : '15px'}
            isIPad={isIPad}
          >
            <ol>
              {infoItems?.map((item, index) => (
                <li key={index}>{`${item}`}</li>
              ))}
            </ol>
            <img
              src={ntvImages.safari_settings_partial}
              alt="safari activation settings steps"
            />
          </ActivationStepsContainer>
        </InfoContentWrapper>
      </InfoContainer>
    </Container>
  );
};

export default NTVPluginActivationPartialPermissions;
